import React, { useState, useEffect } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridFilterToolbarButton,
  GridToolbarExport,
} from "@material-ui/data-grid";
import {
  Typography,
  Button,
  Tooltip,
  IconButton,
  makeStyles,
  TextField,
  Grid,
} from "@material-ui/core";
import ShowAlert from "../../components/ShowAlert";
import IncapacitiesBottomNavigation from "../../components/staff/IncapacitiesBottomNavigation";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DateRangeIcon from "@material-ui/icons/DateRange";
import SearchIcon from "@material-ui/icons/Search";
import red from "@material-ui/core/colors/red";
// redux
import { connect } from "react-redux";
import renderCellExpand from "../../components/renderCellExpand";
import useBrowserContextCommunication from "react-window-communication-hook";
// Services
import { staffAppointmentService } from "../../services/staff/staffAppointmentService";
import { appointmentService } from "../../services/appointmentService";
//Mapeo de clinicas
import { clinicsM } from "../../services/clinicsM";
import { RestorePage } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  heroContent: {
    backgroundImage: `url(https://ecodigital.portubien.co/citapp_user/resources/recursos/img/teleconsultas.jpg)`,
    //backgroundImage: `url(${Background})`,
    backgroundPosition: "center 0%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: theme.spacing(2, 0, 0),
    paddingBottom: "20px",
    //borderRadius: '0px!important',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  field: {
    width: "100%",
  },
  paper: {
    width: "90%",
    height: "100%",
    marginTop: "10px",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingRight: "20px",
    marginBottom: "20px",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    width: 160,
  },
}));

const clinicsMaping = clinicsM.Maping();

function MyExportButton() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

const StaffAuthorizations = (props) => {
  const classes = useStyles();
  const [title, setTitle] = useState("Autorizaciones");
  const [defectColor, setDefectColor] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    new Date(new Date() - 1000 * 60 * 60 * 24)
  );
  const [rowsLoading, setRowsLoading] = useState(false);
  const [rows, setRows] = useState([]);

  const [communicationState, postMessage] = useBrowserContextCommunication(
    "DashboardStaffChanel"
  );

  const [clinicalHistory, setClinicalHistory] = useState("");
  const [formulaMedica, setFormulaMedica] = useState("");
  const [incapacidad, setIncapacidad] = useState("");
  const [ordenes, setOrdenes] = useState("");

  const columnsIncapacities = [
    {
      field: "autorizacion",
      headerName: "Autorización",
      width: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "numero_documento",
      headerName: "Num. Documento",
      width: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "nombre",
      headerName: "Nombre",
      width: 170,
      renderCell: renderCellExpand,
    },
    {
      field: "category",
      headerName: "Categoria",
      width: 200,
      renderCell: renderCellExpand,
    },
    {
      field: "fecha_autorizacion",
      headerName: "Fecha de Autorización",
      width: 200,
      renderCell: renderCellExpand,
    },
    {
      field: "condition",
      headerName: "Condición",
      width: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "solicitante",
      headerName: "Solicitante",
      width: 200,
      renderCell: renderCellExpand,
    },
    {
      field: "procedimiento",
      headerName: "Procedimiento",
      width: 200,
      renderCell: renderCellExpand,
    },
  ];

  useEffect(async () => {
    await getAllAuthorizations();
  }, []);

  const getAllAuthorizations = async () => {
    //Get data
    setRowsLoading(true);

    var list = [
      {
        autorizacion: "186579830",
        numero_documento: "1007794303",
        nombre: "CAPERA_ARIAS,MARIANA_ALEJANDRA",
        category: "CONSULTA MEDICA GENERAL Y ESPECIALISTA",
        fecha_autorizacion: "2022-09-29T07:00:00",
        condition: "ENFERMEDAD GENERAL",
        solicitante: "CLINICA JUAN N CORPAS LTDA",
        procedimiento: "CONSULTA DE CONTROL POR CARDIOLOGIA",
      },
      {
        autorizacion: "830186579",
        numero_documento: "47794303",
        nombre: "MEDINA_CASTRO,JULIAN_ALEJANDRO",
        category: "CONSULTA MEDICA GENERAL Y ESPECIALISTA",
        fecha_autorizacion: "2022-09-29T10:00:00",
        condition: "ENFERMEDAD GENERAL",
        solicitante: "CLINICA JUAN N CORPAS LTDA",
        procedimiento: "CONSULTA DE CONTROL POR CARDIOLOGIA",
      },
      {
        autorizacion: "579830186",
        numero_documento: "1027194321",
        nombre: "SUAREZ_POMBO,CAMILA_MARIA",
        category: "CONSULTA MEDICA GENERAL Y ESPECIALISTA",
        fecha_autorizacion: "2022-09-29T11:30:00",
        condition: "ENFERMEDAD GENERAL",
        solicitante: "CLINICA JUAN N CORPAS LTDA",
        procedimiento: "CONSULTA DE CONTROL POR CARDIOLOGIA",
      },
    ];

    const rowsToRender = list.map((row, index) => {
      return {
        ...row,
        id: index,
      };
    });
    setRows(rowsToRender);
    setRowsLoading(false);
  };

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      {alert.show && <ShowAlert {...alert} />}
      <DataGrid
        autoHeight
        rows={rows}
        loading={rowsLoading}
        columns={columnsIncapacities}
        pageSize={5}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  lastContrat: state.lastContrat,
  clinic: state.clinic,
});

export default connect(mapStateToProps, null)(StaffAuthorizations);
